import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthContext';
import { getProfile } from '../api/profile';

export default function DashboardPage() {
  const { user } = useAuth();

  const { data: profile, isLoading, isError } = useQuery({
    queryKey: ['profile', user?.sub],
    queryFn: () => getProfile(user!.idToken),
    enabled: !!user,
  });

  return (
    <div className="dash-wrap">
      <h1>Welcome{profile?.parentName ? `, ${profile.parentName.split(' ')[0]}` : ''}.</h1>
      <p className="lede">
        This is a placeholder dashboard. The AI tools (video analysis, suggestions, kid pages)
        will land here as we build them.
      </p>

      <div className="dash-card">
        <h2>Your account</h2>
        <dl className="account-grid">
          <dt>Email</dt><dd>{user?.email}</dd>
          {profile && (
            <>
              <dt>Phone</dt><dd>{profile.phoneNumber}</dd>
              <dt>Member since</dt><dd>{new Date(profile.createdAt).toLocaleDateString()}</dd>
            </>
          )}
        </dl>
      </div>

      <div className="dash-card">
        <h2>Your kids</h2>
        {isLoading && <p style={{ color: 'var(--ink-soft)' }}>Loading…</p>}
        {isError && <p style={{ color: 'var(--danger)' }}>Couldn't load profile. Try again later.</p>}
        {profile && profile.kids.length === 0 && <p style={{ color: 'var(--ink-soft)' }}>No kids on file yet.</p>}
        {profile && profile.kids.map((kid, i) => (
          <div key={i} className="kid-row">
            <span>{kid.name}</span>
            <span className="yob">Born {kid.yearOfBirth}</span>
          </div>
        ))}
        {!profile && !isLoading && !isError && (
          <p style={{ color: 'var(--ink-soft)' }}>
            We don't have your profile yet. (Backend may not be deployed.)
          </p>
        )}
      </div>

      <div className="dash-card">
        <h2>Coming soon</h2>
        <ul className="feature-list">
          <li>Upload scrimmage video → AI breakdown</li>
          <li>Kid profile pages (Body / Brain / Bonds goals)</li>
          <li>Parent suggestions, LLM-summarized</li>
          <li>Media gallery with natural-language search</li>
        </ul>
      </div>
    </div>
  );
}
